module.exports = __webpack_public_path__ + "static/img/game-rating-administration-committee-oidd.bb3bdb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/game-rating-administration-committee-oidd.jpg
// module id = uq/3
// module chunks = 0